'use strict';

exports.__esModule = true;
exports.default = createReducers;

function insertEmojis(string) {
  var searches = [' undefined', ' null', ' \'', ' \\[object Object\\]', ' \[0-9\].*'];
  return searches.reduce(function (str, search, index) {
    return str.replace(new RegExp('(' + search + ')', 'g'), ' \uD83D\uDC49$1');
  }, string);
}

function visualValue(value) {
  if (value === null) return 'null';
  if (value === undefined) return 'undefined';
  if (typeof value === 'string') return '\'' + value + '\'';

  if (typeof value === 'function') {
    return value.toString().replace(/\n/g, '').replace(/{(.*)}/g, '{ ... }');
  }

  return value;
}

function objToString(obj) {
  var output = [];
  Object.keys(obj).forEach(function (key) {
    output.push('  ' + key + ': ' + visualValue(obj[key]) + ',');
  });
  return '{\n' + output.join('\n') + '\n}';
}

function validateHandlers(handlers) {
  if (!handlers) {
    throw new Error('Invalid handler: ' + handlers);
  }

  var isInvalid = Object.keys(handlers).some(function (key) {
    return key === '[object Object]' || key === 'undefined' || key === 'null' || typeof handlers[key] !== 'function';
  });

  if (isInvalid) {
    throw new Error('All keys must be valid types and all values should be functions:\n' + insertEmojis(objToString(handlers)) + '\n    ');
  }
}

function createReducers(initialState, handlers) {
  validateHandlers(handlers);
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (!action) {
      return state;
    }

    var handler = handlers[action.type];
    return !handler ? state : handler(state, action);
  };
}